import React from 'react'
import { useAPIRequestStore } from '../../stores/apiStore'
import { API_ENDPOINTS } from '../../config/apiConfig'

const EndpointSelector: React.FC = () => {
  const { selectedEndpoint, setSelectedEndpoint } = useAPIRequestStore()

  const handleEndpointChange = (endpointId: string) => {
    try {
      if (!endpointId) {
        setSelectedEndpoint(null)
        return
      }
      
      const endpoint = API_ENDPOINTS.find(e => e.id === endpointId)
      if (!endpoint) {
        console.warn(`Endpoint with id "${endpointId}" not found`)
        setSelectedEndpoint(null)
        return
      }
      
      setSelectedEndpoint(endpoint)
    } catch (error) {
      console.error('Error selecting endpoint:', error)
      setSelectedEndpoint(null)
    }
  }

  return (
    <div>
      <label className="block text-sm font-medium text-gray-700 dark:text-gray-300 mb-2">
        API Endpoint
      </label>
      <select
        value={selectedEndpoint?.id || ''}
        onChange={(e) => handleEndpointChange(e.target.value)}
        data-api-dropdown
        className="w-full px-3 py-2 border border-gray-300 dark:border-gray-600 rounded-md focus:outline-none focus:ring-2 focus:ring-primary-500 focus:border-transparent bg-white dark:bg-gray-700 text-gray-900 dark:text-white transition-all duration-300"
      >
        <option value="">Select an endpoint...</option>
        {API_ENDPOINTS.map((endpoint) => (
          <option key={endpoint.id} value={endpoint.id}>
            {endpoint.name} - {endpoint.method} {endpoint.path}
          </option>
        ))}
      </select>
    </div>
  )
}

export default EndpointSelector
